import React, { useState } from 'react';
import Select from 'react-select';
import '../../styles/tabs.css';
import ModalTable from '../Tables/BonusesTable';

function BonusesModal({
  closeModal,
  options,
  selectedWeek,
  midMultiSelectStyles,
  selectStyles,
  sampleData,
  downloadTemplate,
  handleFileSelect,
  handleUpload,
  modalLoading,
  toast,
  uploadErrors = [],
  clearUploadErrors,
}) {
  const [selectedDrivers, setSelectedDrivers] = useState([]);

  const handleDriverSelect = (selectedOptions) => {
    setSelectedDrivers(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const filteredData = selectedDrivers.length
    ? sampleData.filter((driver) => selectedDrivers.includes(driver.account_id))
    : sampleData;

  const formattedOptions = filteredData.map((option) => ({
      value: option.account_id,
      label: option.account_name,
  }));

  return (
    <div>
      <div className="fixed inset-0 flex items-center justify-center z-40">
        <div
          className="fixed inset-0 bg-black opacity-50"
          onClick={closeModal}
        />
        <div
          className="bg-white w-1/2 rounded-lg shadow-lg z-10 relative"
          style={{ height: '700px' }}
         >
            {modalLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50 z-40">
                <div className="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
              </div>
            )}
            <div className="flex flex-row justify-end p-2">
              <button
                onClick={closeModal}
                className="absolute right-4 top-4 p-1 border border-gray-300 rounded-full hover:bg-gray-50">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 4L4 12M4 4L12 12"
                    stroke="#6B7280"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div className="p-2 px-6">
              <h2
                style={{ color: '#6E6C71' }}
                className="text-xl font-medium mb-4">
                Upload Bonuses & Earnings
              </h2>
              <div className="mb-6">
                <p className="text-gray-600 mb-4">Uber, Bolt Earnings & Bonuses</p>
                <div className="flex flex-row justify-between">
                  <div className="flex items-start gap-2">
                    <input
                      type="file" 
                      className="px-4 py-2 text-sm"
                      onChange={handleFileSelect}
                      accept=".csv"
                    />
                  </div>

                  <div className="flex items-end">
                    <div className="ml-auto flex gap-1">
                      <button
                        onClick={handleUpload}
                        className="px-6 py-2 bg-purple-700 text-white rounded-md text-sm hover:bg-purple-800"
                      >
                        Upload File
                      </button>
                      <button
                        onClick={downloadTemplate}
                        className="px-6 py-2 bg-purple-700 text-white rounded-md text-sm hover:bg-purple-800">
                        Download Template
                      </button>
                    </div>
                  </div>
                </div>

                {uploadErrors.length > 0 && (
                  <div className="mt-4 border border-red-300 rounded-lg bg-red-50 p-3">
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="text-sm font-medium text-red-800">
                        {uploadErrors.length} error{uploadErrors.length === 1 ? '' : 's'} found
                      </h3>
                      <button
                        onClick={clearUploadErrors}
                        className="text-xs text-red-600 hover:text-red-800 underline">
                        Dismiss
                      </button>
                    </div>
                    <div className="max-h-48 overflow-y-auto">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="border-b border-red-200 text-left text-red-700">
                            <th className="py-1 px-2 w-12">Row</th>
                            <th className="py-1 px-2">Driver</th>
                            <th className="py-1 px-2">Reason</th>
                          </tr>
                        </thead>
                        <tbody>
                          {uploadErrors.map((err) => (
                            <tr key={`${err.row}-${err.driver_id}`} className="border-b border-red-100 text-red-800">
                              <td className="py-1 px-2">{err.row ?? '-'}</td>
                              <td className="py-1 px-2">{err.driver_name ?? 'Unknown'} ({err.driver_id ?? '-'})</td>
                              <td className="py-1 px-2">{err.reason ?? (typeof err === 'string' ? err : 'Unknown error')}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              </div>
              {/* <div
                className="flex flex-row p-1 my-2 rounded-lg justify-items-end items-end"
                style={{ background: '#EEEDF0' }}>
                <div className="w-3/4 flex flex-row space-x-3">
                  <div className="w-1/4">
                    <Select
                      defaultValue={''}
                      placeholder="Driver(s)"
                      isMulti
                      name="drivers"
                      options={formattedOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={midMultiSelectStyles}
                      onChange={handleDriverSelect}
                    />
                  </div>
                  <div className="w-1/4">
                    <Select
                      defaultValue={''}
                      isMulti
                      placeholder="Driver Type"
                      name="colors"
                      options={options}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={midMultiSelectStyles}
                    />
                  </div>
                  <div className="w-1/4">
                    <Select
                      defaultValue={''}
                      isMulti
                      placeholder="[Bonus/Deducts]"
                      name="colors"
                      options={options}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={midMultiSelectStyles}
                    />
                  </div>
                  <div className="w-1/4">
                    <Select
                      defaultValue={''}
                      isMulti
                      placeholder="[Performance]"
                      name="colors"
                      options={options}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={midMultiSelectStyles}
                    />
                  </div>
                </div>
                <div className="flex flex-row space-x-1 w-1/4 mr-1 justify-end items-end">
                  <div className="w-full flex justify-end items-end">
                    <div className="w-3/5 mr-2">
                      <Select
                        value={selectedWeek}
                        onChange={(option) => handleChange(option, 'week')}
                        options={options}
                        placeholder="[KM Overuse]"
                        styles={selectStyles}
                      />
                    </div>
                    <button
                      className="flex items-center justify-center bg-purple-600 rounded-lg focus:outline-none hover:bg-purple-500 active:bg-purple-700 mr-1"
                      style={{ width: '2.4rem', height: '2.4rem' }}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M19 19L13 13M1 8C1 8.91925 1.18106 9.82951 1.53284 10.6788C1.88463 11.5281 2.40024 12.2997 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.1705 14.8189 7.08075 15 8 15C8.91925 15 9.82951 14.8189 10.6788 14.4672C11.5281 14.1154 12.2997 13.5998 12.9497 12.9497C13.5998 12.2997 14.1154 11.5281 14.4672 10.6788C14.8189 9.82951 15 8.91925 15 8C15 7.08075 14.8189 6.1705 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.82951 1.18106 8.91925 1 8 1C7.08075 1 6.1705 1.18106 5.32122 1.53284C4.47194 1.88463 3.70026 2.40024 3.05025 3.05025C2.40024 3.70026 1.88463 4.47194 1.53284 5.32122C1.18106 6.1705 1 7.08075 1 8Z"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      className="flex items-center justify-center rounded-lg focus:outline-none hover:bg-gray-300 active:bg-gray-400"
                      style={{
                        width: '2.4rem',
                        height: '2.4rem',
                        background: '#D9D9D9',
                      }}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M1.06783 10.0397C1.32072 11.969 2.26806 13.74 3.73251 15.0211C5.19697 16.3023 7.07815 17.0058 9.0239 17C10.9697 16.9941 12.8466 16.2794 14.3034 14.9895C15.7601 13.6996 16.6969 11.923 16.9382 9.99228C17.1795 8.06154 16.709 6.10903 15.6145 4.50024C14.5201 2.89145 12.8768 1.73667 10.9924 1.25208C9.10794 0.767482 7.11147 0.986292 5.37671 1.86755C3.64195 2.7488 2.28783 4.23208 1.56783 6.03973M1.06783 1.03973V6.03973H6.06783"
                          stroke="#6E6C71"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div> */}
            </div>

            <div
              className="overflow-y-auto px-4 scrollbar"
              style={{ maxHeight: '300px' }}>
              <ModalTable data={filteredData} />
            </div>
          </div>
        </div>
      </div>
  );
}

export default BonusesModal;
